<template>
  <div class="hours12-item">
    <div id="he-plugin-standard"></div>
  </div>
</template>

<script>
export default {
  created() {
    window.WIDGET = {
      //这里的WIDGET  可以直接整个复制你生成的代码
      CONFIG: {
        layout: "1",
        width: "430",
        height: "150",
        background: "5",
        dataColor: "FFFFFF",
        // 'city': 'CN101280605',  //我这里的城市固定了 你也可以删掉
        key: "55f5c943acff424c97d34b291ba0ecad", //key值 写自己的 自己生成的key值
      },
    };
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://widget.qweather.net/standard/static/js/he-standard-common.js?v=2.0";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
};
</script>
<style lang="less" scoped></style>
